/** Maximum notifications shown in dropdown. */
export const NOTIFICATION_DROPDOWN_LIMIT = 20;
